export const IconEdit = require("../assets/edit.svg");
export const IconPrint = require("../assets/print-gray.svg");
export const IconCalender = require("../assets/calender.png");
export const circleIcon = require("../assets/circle.svg");
